// src/components/Card.jsx
import React from 'react';

const Card = ({ title, value, icon, iconSize='w-[35px] h-[35px]', tailwindWidth, tailwindWHeight, tailwindBgColor, tailwindTextColor, tailwindIconColor, tailwindValueTextSize='text-3xl',  tailwindTitleTextSize='text-sm' }) => {
  const IconComponent = icon; // Ícones de react-icons são componentes

  return (
    <div className={`${tailwindWidth} ${tailwindWHeight} p-6 rounded-lg shadow-lg flex items-center transition-transform duration-200 hover:scale-105 ${tailwindBgColor} ${tailwindTextColor}`}>
      <div className={`p-3 rounded-full mr-4 ${tailwindIconColor || tailwindTextColor} bg-opacity-20`}>
        {IconComponent && <IconComponent className={iconSize} />}
      </div>
      <div>
        <div className={`${tailwindValueTextSize} font-bold`}>{value}</div>
        <div className={`${tailwindTitleTextSize} uppercase tracking-wider`}>{title}</div>
      </div>
    </div>
  );
};

export default Card;